import { render } from "./selectProfileModal.vue?vue&type=template&id=384e2bd2&scoped=true"
import script from "./selectProfileModal.vue?vue&type=script&lang=js"
export * from "./selectProfileModal.vue?vue&type=script&lang=js"

import "./selectProfileModal.vue?vue&type=style&index=0&id=384e2bd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384e2bd2"]])

export default __exports__